import address from '@nextories/vue-core-components/src/i18n/langs/fr/address';
import rooms from '@nextories/vue-core-components/src/i18n/langs/fr/rooms';
import { importDynamicModules } from "@nextories/vue-core-components/src/utils/helpers/format";

const lang = {
  address,
  rooms,
  ...importDynamicModules(import.meta.glob("./*.ts", { eager: true })),
};

export default lang;
